/* iceberg-ui */
import { DonutChart } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Grid, TableCell, TableRow, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/*  Shared  */
import { popoverContentsColumns } from 'application/Shared/Components/Recharts/PopoverContents';
import { ManagedTable } from 'application/Shared/Components/Table';

/* React */
import React, { Component, useMemo } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { Navigate } from 'react-router';
import { withRouter } from 'router/withRouter';

const ApplicationFunnelReports = (props) => {
    const theme = useTheme();
    const { renderingScheduledReport, reportData, reportSetup, reportWrapper } =
        props;
    if (typeof reportData === 'undefined') {
        return null;
    }

    return (
        <>
            {reportData.applicationFunnelAllBreakdown && (
                <ApplicationFunnelAllBreakdown
                    {...props}
                    renderingScheduledReport={renderingScheduledReport}
                    reportSetup={reportSetup}
                    reportData={reportData.applicationFunnelAllBreakdown}
                    theme={theme}
                />
            )}

            {reportData.applicationFunnelAllOverviewBreakdown && (
                <ApplicationFunnelAllOverviewBreakdown
                    renderingScheduledReport={renderingScheduledReport}
                    reportData={
                        reportData.applicationFunnelAllOverviewBreakdown
                    }
                    reportWrapper={reportWrapper}
                />
            )}
        </>
    );
};

class ApplicationFunnelAllBreakdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirectTo: null
        };
    }

    render() {
        const { reportData, reportWrapper, t } = this.props;
        const { redirectTo: stateRedirectTo } = this.state;

        if (
            !!stateRedirectTo &&
            !window.location.href.includes(stateRedirectTo)
        ) {
            return <Navigate to={stateRedirectTo} replace />;
        }

        const funnelLayerTranslations = {
            'Managed Apps': t('FunnelLayer.managedApps'),
            'Unclassified Apps': t('FunnelLayer.unclassifiedApps'),
            'Unmanaged Apps': t('FunnelLayer.unmanagedApps')
        };

        const data = [];

        Object.keys(reportData).forEach((funnelLayer) => {
            const value = reportData[funnelLayer].count;
            const name = funnelLayerTranslations[funnelLayer];
            data.push({ name, value });
        });

        return (
            <Grid item xs={12} style={{ height: '250px' }}>
                {!reportWrapper && (
                    <Typography variant="h5">
                        {t('Reports.ProceduralCodes.Overview')}
                    </Typography>
                )}
                <DonutChart
                    cursor="pointer"
                    emptyMessage={t('Common.noData')}
                    data={data}
                    popoverContentsColumns={popoverContentsColumns}
                    responsiveContainerHeight={250}
                />
            </Grid>
        );
    }
}

const headers = (t) => [
    {
        align: 'left',
        field: 'ilo_application_state',
        renderHeader: <strong>{t('Common.applicationState')}</strong>,
        width: '70%'
    },
    {
        align: 'right',
        field: 'ilo_total_applications',
        renderHeader: <strong>{t('Common.total')}</strong>,
        width: '30%'
    }
];

const ApplicationFunnelAllOverviewBreakdown = ({
    renderingScheduledReport,
    reportData,
    reportWrapper
}) => {
    const { t } = useTranslation();

    const funnelLayerTranslations = {
        'Managed Apps': t('FunnelLayer.managedApps'),
        'Unclassified Apps': t('FunnelLayer.unclassifiedApps'),
        'Unmanaged Apps': t('FunnelLayer.unmanagedApps')
    };

    const funnelLayers = Object.values(reportData).map((funnelLayer) => ({
        count: funnelLayer.count,
        name: funnelLayerTranslations[funnelLayer.name]
    }));

    const rows = useMemo(() => funnelLayers, [funnelLayers]);

    const rowsPerPage = renderingScheduledReport ? -1 : 25;

    const tableHeaders = useMemo(() => headers(t), [t]);

    return (
        <Grid
            item
            xs={12}
            lg={reportWrapper ? 12 : 6}
            style={{ height: '250px' }}
        >
            {!reportWrapper && (
                <Typography variant="h5">
                    {t('Reports.ProceduralCodes.OverviewBreakdown')}
                </Typography>
            )}
            <ManagedTable
                headers={tableHeaders}
                manageRows
                renderBody={(row) => (
                    <React.Fragment key={`ilo_${row.name}`}>
                        <TableRow>
                            <TableCell>{row.name}</TableCell>
                            <TableCell align="right">{row.count}</TableCell>
                        </TableRow>
                    </React.Fragment>
                )}
                renderBodyKey="applicationId"
                renderFooter={false}
                rows={rows}
                rowsPerPage={rowsPerPage}
                searchEnabled={false}
                sortDirection="ASC"
                sortFieldType="string"
                sortKey="name"
            />
        </Grid>
    );
};

export default withRouter(withTranslation()(ApplicationFunnelReports));
